import React from "react";
import Grid from "@material-ui/core/Grid";
import CategoryIcon from "@material-ui/icons/Category";

import useStyles from "./style";

function Empty() {
  const classes = useStyles();
  return (
    <Grid
      item
      container
      direction="column"
      alignItems="center"
      justify="center"
      className={classes.empty}
    >
      <Grid item>
        <CategoryIcon fontSize="large" />
      </Grid>
      <Grid item>No Product Selected</Grid>
    </Grid>
  );
}

export default Empty;
